import openSocket from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/merge';
export function message(type, payload) {
    return { type: type, payload: payload };
}
export function sendUpdateMessage(type, payload) {
    return { type: 'SEND_UPDATE', message: message(type, payload) };
}
function updateReceived(message) {
    return { type: 'UPDATE_RECEIVED', message: message };
}
export var websocketEpic = function (action$, store) {
    // TODO: if authentication is turned on, construct the socket only after auth success
    var socket = openSocket('/');
    return action$.ofType('SEND_UPDATE')
        .do(function (a) { return socket.emit('update', a.message.type, a.message.payload); })
        .map(function (a) { return updateReceived(a.message); })
        .merge(new Observable(function (observer) {
        socket.on('update', function (type, payload) { return observer.next(updateReceived(message(type, payload))); });
        return function () { return socket.disconnect(); };
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/websocket.ts
// module id = 34
// module chunks = 0